import { categoryList } from "./categories";

export const RegionalLocationList = [
  "The Atlantic Region",
  "Central Canada",
  "The Prairie Provinces",
  "The West Coast",
  "The North",
  "Newfoundland and Labrador",
  "Prince Edward Island",
  "Nova Scotia",
  "New Brunswick",
];

export const CANADIAN_PROVINCES = [
  { code: "AB", name: "Alberta" },
  { code: "BC", name: "British Columbia" },
  { code: "MB", name: "Manitoba" },
  { code: "NB", name: "New Brunswick" },
  { code: "NL", name: "Newfoundland and Labrador" },
  { code: "NT", name: "Northwest Territories" },
  { code: "NS", name: "Nova Scotia" },
  { code: "NU", name: "Nunavut" },
  { code: "ON", name: "Ontario" },
  { code: "PE", name: "Prince Edward Island" },
  { code: "QC", name: "Quebec" },
  { code: "SK", name: "Saskatchewan" },
  { code: "YT", name: "Yukon" },
];

export const Provinces = CANADIAN_PROVINCES.map(({ name }) => name);
export const formatEventType = (key, value) => {
  //console.log('value is', value)
  let filteredList;
  if (key === "key") {
    filteredList = categoryList.find((category) => category.key === value);
    if (!filteredList) {
      console.warn(`No matching category found for value: ${value}`);
      return ""; // Or return a default value
    }
    return filteredList.value;
  }

  if (key === "value") {
    filteredList = categoryList.find((category) => category.value === value);
    if (!filteredList) {
      console.warn(`No matching category found for value: ${value}`);
      return ""; // Or return a default value
    }
    return filteredList.key;
  }
};
